import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=127e3b14&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=127e3b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e3b14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('127e3b14')) {
      api.createRecord('127e3b14', component.options)
    } else {
      api.reload('127e3b14', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=127e3b14&scoped=true&", function () {
      api.rerender('127e3b14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Ob52oKKH6kr9/JS/comp/PopupDialog.vue"
export default component.exports